import { Ref } from 'vue';
import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { GetReportListRequest } from '@/api/report/get-report-list.request';
import { GetReportListCsvRequest } from '@/api/report/get-report-list-csv.request';

export class ReportApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly apiUrl: Ref<string>,
  ) { }

  public get getReportListRequest(): GetReportListRequest {
    return new GetReportListRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/report/mga`,
      HttpMethods.GET,
    );
  }

  public get getReportListCsvRequest(): GetReportListCsvRequest {
    return new GetReportListCsvRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/report/mga/csv`,
      HttpMethods.GET,
    );
  }
}
